/**
 * Created by razial on 17.10.2022
 */

const DeleteAccountInformationWindow = CleverappsWindow.extend({
    onWindowLoaded: function () {
        const styles = cleverapps.styles.DeleteAccountWindow;

        this._super({
            name: "DeleteAccountInformationWindow",
            title: Messages.get("DeleteAccountInformationWindow.title"),
            content: this.createContent(),
            styles: styles.window,
            closeButton: false
        });
    },

    createContent: function () {
        const styles = cleverapps.styles.DeleteAccountWindow;

        const info = this.createInfo();
        const buttons = this.createButtons();

        return new cleverapps.Layout([info, buttons], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });
    },

    createInfo: function () {
        const styles = cleverapps.styles.DeleteAccountWindow.info;

        const daysLeft = Math.floor((cleverapps.userDelete.getTimeLeft() - 1000) / 24 / 60 / 60 / 1000) + 1;

        const messages = [
            Messages.get("DeleteAccountInformationWindow.time", {
                days: daysLeft
            }),
            Messages.get("DeleteAccountInformationWindow.text1", {
                newline: "\n"
            }),
            Messages.get("DeleteAccountInformationWindow.text2", {
                newline: "\n"
            })
        ];

        if (connector.platform.oneOf(connector.IOS, connector.MACOS)) {
            messages.push(Messages.get("DeleteAccountInformationWindow.revoke.apple", {
                newline: "\n"
            }));
        }

        const texts = messages.map((message) => {
            const text = cleverapps.UI.generateOnlyText(message, cleverapps.styles.FONTS.DELETE_ACCOUNT_TEXT);
            text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
            text.setWrapWidth(styles.text.size[cleverapps.resolution.mode].width);
            return text;
        });

        const info = new cleverapps.Layout(texts, {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin,
            padding: styles.padding
        });
        info.setAlignment(info.width / 2, info.height / 2);

        const background = cleverapps.UI.createScale9Sprite(bundles.windows.frames.windows_details_bg_png, cleverapps.UI.Scale9Rect.TwoPixelXY);
        background.setContentSize(info.width, info.height);
        background.addChild(info);

        return background;
    },

    createButtons: function () {
        const styles = cleverapps.styles.DeleteAccountWindow.buttons;

        const cancelButton = new cleverapps.UI.Button({
            type: cleverapps.styles.UI.Button.Images.button_green,
            text: Messages.get("Cancel"),
            onClicked: function () {
                this.close();
                cleverapps.userDelete.cancelDeletion();
            }.bind(this),
            width: styles.width,
            height: styles.height
        });

        let exitButton;
        if (SettingsWindow.IsExitButtonAvailable()) {
            exitButton = new cleverapps.UI.Button({
                type: cleverapps.styles.UI.Button.Images.button_red,
                text: Messages.get("Exit"),
                onClicked: function () {
                    connector.platform.closeApplication();
                },
                width: styles.width,
                height: styles.height
            });
        }

        return new cleverapps.Layout([cancelButton, exitButton].filter(Boolean), {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.margin
        });
    }
});
